(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["perleni-scent-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('perleni-scent-filter')) {
    customElements.define('perleni-scent-filter', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const initialize = () => {
          this.grid = document.getElementById(this.dataset.gridId);
          if (!this.grid) return;
          this.items = Array.from(this.grid.children).filter((item) => item.matches('li'));
          if (!this.items.some((item) => item.querySelector('[data-perleni-scent-families]'))) return;
          this.buttons = Array.from(this.querySelectorAll('[data-scent-family]'));
          this.description = this.querySelector('[data-scent-description]');
          this.count = this.querySelector('[data-scent-count]');
          const scope = this.closest('.shopify-section');
          const selected = scope?.dataset.perleniScentFamily || 'all';
          this.applyFilter(selected);
          this.hidden = false;
          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-scent-family]');
            if (!button || !this.contains(button)) return;
            this.applyFilter(button.dataset.scentFamily);
            if (scope) scope.dataset.perleniScentFamily = button.dataset.scentFamily;
          }, { signal });
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
        } else {
          initialize();
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      applyFilter(family) {
        const selectedButton = this.buttons.find((button) => button.dataset.scentFamily === family) || this.buttons[0];
        if (!selectedButton) return;
        family = selectedButton.dataset.scentFamily;
        let count = 0;
        let soonCount = 0;
        this.items.forEach((item) => {
          const families = item.querySelector('[data-perleni-scent-families]')?.dataset.perleniScentFamilies.split(' ') || [];
          const visible = family === 'all' || families.includes(family);
          item.hidden = !visible;
          item.toggleAttribute('data-perleni-filter-hidden', !visible);
          if (visible && item.querySelector('[data-perleni-available="true"]')) count += 1;
          if (visible && item.querySelector('[data-perleni-available="false"]')) soonCount += 1;
        });
        this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === selectedButton)));
        this.description.textContent = selectedButton.dataset.description;
        const countParts = [];
        if (count > 0 || soonCount === 0) countParts.push(this.dataset.countLabel.replace('[count]', String(count)));
        if (soonCount > 0) countParts.push(this.dataset.soonCountLabel.replace('[count]', String(soonCount)));
        this.count.textContent = countParts.join(' · ');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["perleni-scent-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('perleni-scent-picker')) {
    customElements.define('perleni-scent-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        this.querySelector('select')?.addEventListener('change', (event) => {
          const url = new URL(event.target.value, window.location.origin);
          if (url.origin === window.location.origin) window.location.assign(url.href);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
